export var CircleVisualSubType;
(function (CircleVisualSubType) {
    CircleVisualSubType["Doughnut"] = "doughnut";
    CircleVisualSubType["Pie"] = "pie";
    CircleVisualSubType["Nested"] = "nested";
})(CircleVisualSubType || (CircleVisualSubType = {}));
//# sourceMappingURL=circleVisualSubType.js.map